/**
 * PM 下拉選項（狀態、優先級、專案類型）：值的清單與後端驗證相同，標籤走翻譯 pages:<ns>.<group>.<值>
 */
import { TFunction } from 'i18next';

export interface StatusOption {
  value: string;
  label: string;
}

const PROJECT_STATUSES = ['PLANNING', 'IN_PROGRESS', 'ON_HOLD', 'DELIVERED', 'COMPLETED', 'CANCELLED'];
const PROJECT_TYPES = ['WEBSITE', 'MOBILE_APP', 'SYSTEM', 'DESKTOP_APP', 'OTHER'];
const REQUIREMENT_STATUSES = ['PENDING', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED'];
const MILESTONE_STATUSES = ['PENDING', 'IN_PROGRESS', 'COMPLETED'];
const PACKAGE_STATUSES = ['PENDING', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED'];
const TASK_STATUSES = ['PENDING', 'IN_PROGRESS', 'COMPLETED', 'BLOCKED'];
const PRIORITIES = ['LOW', 'MEDIUM', 'HIGH'];
const HOLD_REASONS = ['CLIENT_UNRESPONSIVE', 'CLIENT_REQUEST', 'WAITING_CLIENT', 'INTERNAL', 'OTHER'];

const options = (t: TFunction, prefix: string, values: string[]): StatusOption[] =>
  values.map(value => ({ value, label: t(`${prefix}.${value}`, { ns: 'pages' }) }));

export const getProjectStatusOptions = (t: TFunction) => options(t, 'pmProjects.status', PROJECT_STATUSES);
/** 專案暫停原因（狀態為暫停中時填） */
export const getHoldReasonOptions = (t: TFunction) => options(t, 'pmProjects.holdReason', HOLD_REASONS);
export const getProjectTypeOptions = (t: TFunction) => options(t, 'pmProjects.projectTypes', PROJECT_TYPES);
export const getRequirementStatusOptions = (t: TFunction) => options(t, 'pmRequirements.status', REQUIREMENT_STATUSES);
export const getMilestoneStatusOptions = (t: TFunction) => options(t, 'pmMilestones.status', MILESTONE_STATUSES);
export const getPackageStatusOptions = (t: TFunction) => options(t, 'pmPackages.status', PACKAGE_STATUSES);
export const getTaskStatusOptions = (t: TFunction) => options(t, 'pmTasks.status', TASK_STATUSES);
/** 優先級（需求 pmRequirements、任務 pmTasks 各有一組翻譯） */
export const getPriorityOptions = (t: TFunction, ns: 'pmRequirements' | 'pmTasks') => options(t, `${ns}.priority`, PRIORITIES);
